import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import { SdgProject } from '../../types';
import useSliderProperties from './hooks/useSliderProperties';
import SdgItem from './SdgItem';
import useSetInitialFocusOnlyOnActiveSlides from './hooks/useSetInitialFocusOnlyOnActiveSlides';
import { setFocusOnlyOnActiveSlides, setSlickArrowDisabled, setSlickArrowEnabled } from './utils';


type SdgMainProps = {
  displayType: string;
  sdgProjects: SdgProject[];
  mainFocusText?: string;
  allProjectsLink?: string;
  buttonPrevLabel?: string;
  buttonNextLabel?: string;
};

const SdgMain = ({ displayType, sdgProjects, mainFocusText = '', allProjectsLink = '', buttonPrevLabel = '', buttonNextLabel = '' }: SdgMainProps): JSX.Element => {
  const { slidesToShow, slidesToScroll } = useSliderProperties();
  const [display, setDisplay] = useState(displayType);
  useSetInitialFocusOnlyOnActiveSlides();
  useEffect(() => {
    setSlickArrowDisabled();
  }, [])

  if (display === 'slider' && (sdgProjects.length > slidesToShow)) {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow,
      slidesToScroll,
      prevArrow: <button type="button" className="slick-prev" aria-label={buttonPrevLabel}>{buttonPrevLabel}</button>,
      nextArrow: <button type="button" className="slick-next" aria-label={buttonNextLabel}>{buttonNextLabel}</button>,
      appendDots: (dots: string | number | boolean | {} | React.ReactElement<any, string | React.JSXElementConstructor<any>> | React.ReactNodeArray | React.ReactPortal | null | undefined) => (
        <div>
          <ul style={{ margin: "0px" }}> {dots} </ul>
        </div>
      ),
      customPaging: (i: number) => (
        <>
          <div className="currentDot">
            {i + 1}&nbsp;/&nbsp;
          </div>
          <div className="lastDot">
            {i + 1}
          </div>
        </>
      ),
      afterChange: () => {setFocusOnlyOnActiveSlides();
        setSlickArrowDisabled();
      }, beforeChange: () => setSlickArrowEnabled()
    };
    return (
      <>
        <div id="sdg-slider">
          <Slider {...settings}>
            {sdgProjects.map((sdgProject) => (
              <div className="sdg-item" key={sdgProject.id}>
                <SdgItem {...{ sdgProject, mainFocusText }} />
              </div>
            ))}
            {/* // the following line is for cosmetic reasons */}
            {sdgProjects.length % slidesToShow !== 0 ? Array(slidesToShow - sdgProjects.length % slidesToShow).fill({}).map((_, index) => (<div key={index} />)): null}
          </Slider>
          <div className="all-projects-link" dangerouslySetInnerHTML={{__html:allProjectsLink}}/>
        </div>
      </>
    );
  }
  return (
    <div id="sdg-items-list" className="sdg-items-list">
      {sdgProjects.map((sdgProject) => (
        <div className="sdg-item" key={sdgProject.id}>
          <SdgItem {...{ sdgProject, mainFocusText }} />
        </div>
      ))}
    </div>
  );
};

export default SdgMain;
